import type { FC, PropsWithChildren } from "react";
import React from "react";

import classes from "./SelectionCellContent.styl";

const SELECTION_CELL_CONTENT_TEST_ID = "selection-cell-content-test-id";

export interface IContent {}

type ContentProps = PropsWithChildren<IContent>;

export const SelectionCellContent: FC<ContentProps> = ({ children }) => {
    return children ? (
        <div
            className={classes["cell-content"]}
            data-tsid={SELECTION_CELL_CONTENT_TEST_ID}
        >
            {children}
        </div>
    ) : null;
};

SelectionCellContent.displayName = "SelectionCell.Content";

export default SelectionCellContent;
